module.exports = __webpack_public_path__ + "4e0cc3f92553f71697e12d0a175ef6ad.webp";